import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/athos/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/athos/components/collection/filters/FilterSelected'
import { FilterSort } from 'libs/athos/components/collection/filters/FilterSort'
import { useFilters } from 'libs/athos/hooks/useFilters'
import { useAthosContext } from 'libs/athos/fetchers/provider'
import { useEffect, useRef } from 'preact/hooks'

export function FilterDrawer({ id = 'filters', showFilters = false }) {
  const {
    handleClearFilters,
    handleToggleFilter,
    handleRemoveFilter,
    initialFilters,
    activeFilters,
    fetchedFilters
  } = useFilters()

  const { results, isLoading } = useAthosContext()
  const totalResults = results?.pagination?.totalResults || 0
  const initialLoadDone = useRef(false)
  const isDesktop = useRef(window.innerWidth >= 1024)

  useEffect(() => {
    if (!showFilters || !isDesktop.current || initialLoadDone.current) return
    if (isLoading || !results) return

    initialLoadDone.current = true
    document.querySelector('#toggle-filters')?.click()
  }, [isLoading, results, showFilters])

  return (
    <x-modal
      className="group/filters lg-max:z-60"
      data-id={id}
    >
      <div className="flex flex-col fixed lg:sticky top-0 lg:top-[calc(var(--height-header-adapt)+60px)] left-0 w-full lg:w-0 group-data-visible/filters:lg:w-grid-1/4-window group-data-visible/filters:xxl:w-grid-1/5-window h-view lg:h-fit pointer-events-none group-data-visible/filters:pointer-events-auto lg-max:z-60 transition-all">
        <div className="flex flex-col w-full lg:w-grid-1/4-window xxl:w-grid-1/5-window lg-max:h-full lg-max:max-w-[335px] lg-max:bg-secondary -translate-x-full-margin group-data-visible/filters:translate-x-0 z-2 transition-all">
          <div class="lg:hidden shrink-0 flex flex-col lg:gap-y-1 lg:pt-1.375 lg:pb-1">
            <div className="flex gap-x-gutter items-center justify-between w-full h-[46px] pl-margin border-b border-borders-default">
              <h2 className="paragraph-l font-extended font-semibold">Filter & Sort</h2>
              <button
                className="btn btn-transparent btn-primary btn-m btn-square"
                data-modal-parent={id}
                data-modal-role="close"
                aria-label="Close Filters"
              >
                <div className="size-[9px] children:size-full">
                  <Icon id="close" />
                </div>
              </button>
            </div>
            {activeFilters.size > 0 && (
              <div className="px-margin py-0.5 border-b border-borders-default">
                <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
              </div>
            )}
          </div>
          <div className="grow flex flex-col overflow-y-scroll no-scrollbar -mb-px">
            <FilterSort />
            {initialFilters.length > 0 ? (
              initialFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  onRemove={handleRemoveFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <p className="px-margin py-1 text-type-black-secondary">No filters available</p>
            )}
          </div>
          <div className="shrink-0 flex lg:hidden gap-x-1 w-full px-margin py-1 border-t border-borders-default">
            {activeFilters.size > 0 && (
              <button
              className="btn btn-primary btn-border btn-m"
              onClick={handleClearFilters}
              aria-label="Clear Filters"
            >
              <span>
                Clear
              </span>
            </button>
            )}
            <button
              className="grow btn btn-primary btn-fill btn-m"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="Show Products"
            >
              <span>
                Show {totalResults} Products
              </span>
            </button>
          </div>
        </div>
        <button
            class="lg:hidden fixed inset-tl size-full bg-brand-primary/60 opacity-0 group-data-visible/filters:opacity-100 pointer-events-none group-data-visible/filters:pointer-events-auto cursor-w-resize transition-all"
            data-modal-parent={id}
            data-modal-role="close"
            aria-label="Close Filters"
          >
          </button>
      </div>
    </x-modal>
  )
}
